module.exports = {
	"library.footer.terms_of_use": "Bruksvilkår",
	"library.footer.terms_and_conditions": "Terms and Conditions",
	"library.footer.privacy_policy": "Personvernerklæring",
	"library.footer.get_to_know_us": "Bli kjent med oss",
	"library.footer.about": "Om oss",
	"library.footer.jobs": "Jobber",
	"library.footer.blog": "Blog",
	"library.footer.get_help": "Få hjelp",
	"library.footer.find_events": "Finn arrangementer",
	"library.footer.top_events": "Populære arrangement",
	"library.footer.host_events": "Sett opp arrangementer",
	"library.footer.become_a_host": "Lag arrangement",
	"library.footer.tour": "Omvisning",
	"library.footer.embeddable_widgets": "Moduler som kan bygges inn",
	"library.footer.customers": "Kunder",
	"library.footer.pricing": "Priser",
	"library.footer.get_the_onsite_app": "Skaff appen",
	"library.footer.developers": "Utviklere",
	"library.footer.contact_us": "Kontakt oss"
};


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/footer/translations/nb.json
// module id = 1599
// module chunks = 0 1 2 4 5 6 7 8 9 10 11 12 13 14 15 16